import React, { useState, useEffect } from 'react'
import { Select } from 'antd'
import { queryChannelRegionList, querySupplierRegionList } from '@/services/category'
import styles from './index.less'

const RegionSelect = ({ type, form, name, ...restProps }) => {
    const [options, setOptions] = useState([])

    useEffect(() => {
        init()
    }, [type])

    const init = async () => {
        let regionJson = null
        if (type === 'supplier') {
            regionJson = await querySupplierRegionList()
        } else {
            regionJson = await queryChannelRegionList()
        }

        const { success, data } = regionJson

        if (success && Array.isArray(data)) {
            const list = data.map(item => ({
                label: item,
                value: item
            }))

            setOptions(list)
        }
    }

    form?.setLocalData?.(name, {
        init,
        options: options
    })

    return (
        <Select
            showSearch
            className={styles.container}
            options={options}
            allowClear
            placeholder="请选择大区"
            {...restProps}
        />
    )
}

export default RegionSelect
